export default {"src":"/_next/static/media/logo.691eba7a.svg","height":111,"width":407,"blurWidth":0,"blurHeight":0};